import PlanCard from "@components/PlanCard"
import SubscriptionForm from "@components/SubscriptionForm"
import { useTranslation } from "react-i18next"
import { Plan, StripePrice } from "src/types"

interface Props {
  currency: string
  isSubmitting: boolean
  setIsSubmitting: (isSubmitting: boolean) => void
  timeLeft: string
  weeklyIntroPrice: StripePrice | undefined
  weeklyPrice: StripePrice | undefined
  yearlyIntroPrice: StripePrice | undefined
  yearlyPrice: StripePrice | undefined
  selectedPlan: Plan
  onPlanChange: (plan: Plan) => void
}

export default function Plans({
  currency,
  isSubmitting,
  setIsSubmitting,
  timeLeft,
  weeklyIntroPrice,
  weeklyPrice,
  yearlyIntroPrice,
  yearlyPrice,
  selectedPlan,
  onPlanChange,
}: Props) {
  const { t } = useTranslation()

  const getSelectedPriceId = () => {
    if (selectedPlan === "weekly") {
      return weeklyIntroPrice?.id
    }
    return yearlyIntroPrice?.id
  }

  const getSelectedFullPrice = () => {
    if (selectedPlan === "weekly") {
      return weeklyPrice
    }
    return yearlyPrice
  }

  return (
    <div className="space-y-4 sm:space-y-6">
      <PlanCard
        bestOffer={true}
        currency={currency}
        isSubmitting={isSubmitting}
        periodAmount={1}
        periodUnit="year"
        plan="yearly"
        setIsSubmitting={setIsSubmitting}
        stripeIntroPrice={yearlyIntroPrice}
        stripePrice={yearlyPrice}
        timeLeft={timeLeft}
        isSelected={selectedPlan === "yearly"}
        onSelect={() => onPlanChange("yearly")}
      />

      <PlanCard
        currency={currency}
        isSubmitting={isSubmitting}
        periodAmount={1}
        periodUnit="week"
        plan="weekly"
        setIsSubmitting={setIsSubmitting}
        stripeIntroPrice={weeklyIntroPrice}
        stripePrice={weeklyPrice}
        timeLeft={timeLeft}
        isSelected={selectedPlan === "weekly"}
        onSelect={() => onPlanChange("weekly")}
      />

      <div className="space-y-3">
        <SubscriptionForm
          buttonClassName="custom-button-primary uppercase"
          buttonTitle={t("pages.checkout.plans.continue")}
          currency={currency}
          fullPrice={getSelectedFullPrice()}
          isSubmitting={isSubmitting}
          plan={selectedPlan}
          priceId={getSelectedPriceId()}
          setIsSubmitting={setIsSubmitting}
        />

        <p className="text-center text-sm font-normal">
          {t("pages.checkout.plans.cancelAnytime")}
        </p>

        <p className="text-center text-sm font-bold">
          {t("pages.checkout.plans.moneyBackGuarantee")}
        </p>
      </div>
    </div>
  )
}
